exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".messageMode{position:fixed;left:0;top:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:99}.saveMessage{position:absolute;top:6.2rem;left:10%;width:80%;height:4.026667rem;text-align:center;background-color:#fff;color:#333;z-index:100}.saveMessage h5{font-size:.4rem;margin:.853333rem 0 .4rem;font-weight:700}.saveMessage p{font-size:.346667rem}.saveMessage .btn-group{border-top:.026667rem solid #dbdbdb;position:absolute;bottom:0;width:100%;display:-webkit-box;display:-webkit-flex;display:flex}.saveMessage .btn-group li{text-align:center;height:1rem;line-height:1rem;-webkit-box-flex:1;-webkit-flex:1;flex:1}.saveMessage .btn-group li:first-child{border-right:.026667rem solid #e9e9e9}.saveMessage .cancel{color:#f22f2f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-188f8935","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Confirm.vue
// module id = 417
// module chunks = 0